import React,{useState} from "react";
import cn from 'classnames';
import styles from './/Tooltip.scss'


function Layouttooltip(props) {
    const [displayTooltip, setdisplayTooltip] = useState(null)

    const hideTooltip = () => {
      setdisplayTooltip(false)
    }
    const showTooltip = () => {
      setdisplayTooltip(true)
    }
    let message = props.rightName
    let position = props.position
   
    return (
      <span className={cn(styles.tooltip)}
          onMouseLeave={hideTooltip}
        >
        {displayTooltip &&
        <div className= {cn(styles.tooltip,position==='leftPositon'?'leftTooltip':'rightTooltip')}>
          <div className= {cn(message!==undefined?'':styles.displayNone)}>
              <span>VE-Name:</span><span></span><br/>
              <span> Session start time: </span><span></span><br/>
              <span>End time: </span><span></span><br/>
              <span>Current SoC:</span><span></span><br/>
              <span>Target SoC:</span><span></span><br/>
              <span>Net Power Consumption:</span><span></span><br/>
          {/* <span>
          VE-Name-123 • BlueBird Class C 125kWh • 100% Session start time: End time: Current SoC: Target SoC: Net Power Consumption:
          </span> */}
         </div>
        </div>
        }
        <span 
          className= 'tooltip-trigger'
          onMouseOver={
            props.status == 'portError' || props.status == 'Available' ? hideTooltip : 
            showTooltip
          }
          >
          {props.children}
        </span>
      </span>
    )
}
export default Layouttooltip